import { METHODS } from "../../config";
import { ENDPOINTS } from "../../config/endpoints";
import { fetchData } from "../../utils/fetchData";

export const getPostList = async () => {
  const data = await fetchData(ENDPOINTS.GET.POST_LIST, {
    method: METHODS.GET,
  });
  return data;
};
